<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import blipModel from '@/mixins/blip-model';

export default {
  name: 'BlipReportsTicketsCount',
  components: {
    SimpleDataWithVariation,
  },
  mixins: [
    blipModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    servicePath: {
      type: String,
      required: true,
    },
    ticketType: {
      type: Array,
      default: () => [],
    },
    timingType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipServiceWithVariation',
      'hasNoBlipBotAndContractFiltered',
      'getAppliedCardFilter',
    ]),
    async getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (await this.hasNoBlipBotAndContractFiltered(this.itemId)) {
        this.requestStatus = 'emptyBot';
        return;
      }

      this.getBlipServiceWithVariation({
        servicePath: this.servicePath,
        itemId: this.itemId,
      })
        .then((response) => {
          const [ticketType1, ticketType2] = this.ticketType;

          !this.timingType
            ? this.responseTickets(response, ticketType1, (ticketType2 ? ticketType2 : ''))
            : this.responseTimings(response, this.timingType);

          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = error.message;
        });
    },
  },
};
</script>
